import { Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Dialog from '../Dialog';
import { DIALOG_SIZE } from '../form/enum/formProps';

import './ActionConfirmationDialog.scss';

interface ActionConfirmationDialogProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  title: string;
  text: string;
}

const ActionConfirmationDialog: React.FC<ActionConfirmationDialogProps> = (props) => {
  const { t } = useTranslation();
  const { open, onConfirm, onClose, title, text } = props;
  return (
    <Dialog
      open={open}
      disableBackdropClick={true}
      title={title}
      dialogSize={DIALOG_SIZE.SM}
      fullWidth={true}
      buttonActionLabel={'button.delete'}
      onSave={onConfirm}
      onClose={onClose}
    >
      <Typography className="Confirmation-text">{t(text)}</Typography>
    </Dialog>
  );
};

export default ActionConfirmationDialog;
